import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import { Menu } from "@/modules/Menu";
import { MainteInfo } from "@/modules/MainteInfo";
import createPersistedState from 'vuex-persistedstate';
import * as Common from '../commons/common';
import { SheetListCondition } from "../modules/teacher/SheetList";
import { CbtSheetListCondition } from "../modules/teacher/CbtSheetList";
import { EntranceSheetListCondition } from "../modules/teacher/EntranceSheetList";
import { EntranceCompareSheetListCondition } from "../modules/teacher/EntranceCompareSheetList";
import { PracticeCompareSheetListCondition } from "../modules/teacher/PracticeCompareSheetList";
import { PracticeSheetListCondition } from "../modules/teacher/PracticeSheetList";
import { HomeworkSheetListCondition } from "../modules/teacher/HomeworkSheetList";
import { SearchCondition as WebupListCondition } from "@/modules/teacher/WebupList"
import router from "@/router/index";
import isMobileJS from 'ismobilejs'
import { SumupListCondition } from '@/modules/teacher/SumupList';

Vue.use(Vuex)

export type StateType = {
  currentUser: any
  isShowOverlay: boolean
  overlayText: string
  schools: any[]
  curriculums: any[]
  viewPoints: any[]
  grades: any[]
  months: any[]
  roles: any[]
  teacherRoles: any[]
  entranceTeacherRoles: any[]
  correct_texts: any[]
  digital_answer_types: any[]
  scoring_types: any[]
  assessment_score_types: any[]
  genders: any[]
  sheetType: number
  sheetListCondition: SheetListCondition
  cbtSheetListCondition: CbtSheetListCondition
  entranceSheetListCondition: EntranceSheetListCondition
  entranceCompareSheetListCondition: EntranceCompareSheetListCondition
  practiceExamSheetListCondition: PracticeSheetListCondition
  practiceCompareSheetListCondition: PracticeCompareSheetListCondition
  homeworkSheetListCondition: HomeworkSheetListCondition,
  sumupListCondition: SumupListCondition
  webupListCondition: WebupListCondition
  isMobile: boolean,
  isHeaderDisp: boolean,
  mainteInfo: MainteInfo,
  defaultSheetType: number,
  otp_login_id: string,
  sumupResultCurriculumId: number
  sumupDetailCurriculumId: number
  gauthCredentials: string,
  gauthRedirectPath: string,
  isDigitalPaper: boolean,
  digitalPaperEmail: string
  isKaitouViewReloaded: boolean
  isShowingMsgBox: boolean
  student_no_character: string
  student_name: string
  sumup_units: any[]
  practiceCurriculumIds: number[]
  nendo: string
  exec_times: string
  practice_examinee_id: number
  base64_school_logo: string
  isRecogPositionEditEnable: boolean
  next_field_type: number
  start_sheet_id: number
  compare_no: number
  sheet_field_idx: number
  saitenListDisplayLeft: number
  isFilterMisaiten: boolean | null
  schoolSubjects: any[]
  isShowProgress: boolean
  progressText: string
  markRecogResultColCount: number
  resizeStickSize: number
  textDirection: number
  fontSize: number
  lineHeight: number
}

export default new Vuex.Store({
  state: {
    currentUser: null,
    isShowOverlay: false,
    overlayText: "",
    schools: [],
    curriculums: [],
    viewPoints: [],
    grades: Common.GetComboboxGradeArray(),
    months: Common.GetComboboxMonthArray(),
    roles: Common.GetComboboxRoleArray(),
    teacherRoles: Common.GetComboboxTeacherRoleArray(),
    entranceTeacherRoles: Common.GetComboboxEntranceTeacherRoleArray(),
    correct_texts: Common.GetComboboxCorrectTextArray(),
    scoring_types: Common.GetComboboxScoingTypeArray(),
    digital_answer_types: Common.GetComboboxDigitalAnswerTypeArray(),
    genders: Common.GetComboboxGenderArray(),
    assessment_score_types: Common.GetComboboxAssessmentScoreTypeArray(),
    sheetType: 0,
    sheetListCondition: new SheetListCondition(),
    cbtSheetListCondition: new CbtSheetListCondition(),
    entranceSheetListCondition: new EntranceSheetListCondition(),
    entranceCompareSheetListCondition: new EntranceCompareSheetListCondition(),
    practiceExamSheetListCondition: new PracticeSheetListCondition(),
    practiceCompareSheetListCondition: new PracticeCompareSheetListCondition(),
    sumupListCondition: new SumupListCondition(),
    homeworkSheetListCondition: new HomeworkSheetListCondition(),
    webupListCondition: new WebupListCondition(),
    isMobile: isMobileJS(window.navigator).phone || isMobileJS(window.navigator).tablet,
    isHeaderDisp: true,
    mainteInfo: new MainteInfo([]),
    defaultSheetType: 0,
    otp_login_id: "",
    gauthCredentials: "",
    gauthRedirectPath: "",
    isDigitalPaper: false,
    digitalPaperEmail: null,
    isKaitouViewReloaded: false,
    isShowingMsgBox: false,
    student_no_character: null,
    student_name: null,
    sumup_units: [],
    practiceCurriculumIds: [],
    nendo: null,
    exec_times: null,
    practice_examinee_id: null,
    base64_school_logo: null,
    isRecogPositionEditEnable: false,
    next_field_type: null,
    start_sheet_id: null,
    sheet_field_idx: null,
    saitenListDisplayLeft: null,
    isFilterMisaiten: null,
    schoolSubjects: [],
    isShowProgress: false,
    progressText: null,
    markRecogResultColCount: 10,
    resizeStickSize: isMobileJS(window.navigator).phone || isMobileJS(window.navigator).tablet ? 12 : 8,
    textDirection: Common.DirectionEnum.Horizon,
    fontSize: null,
    lineHeight: null,
  } as StateType,
  mutations: {
    setCurrentUser(state, user: any){
      state.currentUser = user;
    },
    setCurrentUserSchoolId(state, school_id: any){
      state.currentUser.school_id = school_id;
    },
    setCurrentUserSchoolOptions(state, school_options: any){
      state.currentUser.school_options = school_options;
    },
    setSchools(state, schools: []){
      state.schools = schools;
    },
    setCurriculums(state, curriculums: []){
      state.curriculums = curriculums;
    },
    setViewPoints(state, viewPoints: []){
      state.viewPoints = viewPoints;
    },
    setSheetListCondition(state, condition: SheetListCondition){
      state.sheetListCondition = condition;
    },
    setCbtSheetListCondition(state, condition: CbtSheetListCondition){
      state.cbtSheetListCondition = condition;
    },
    setEntranceSheetListCondition(state, condition: EntranceSheetListCondition){
      state.entranceSheetListCondition = condition;
    },
    setEntranceCompareSheetListCondition(state, condition: EntranceCompareSheetListCondition){
      state.entranceCompareSheetListCondition = condition;
    },
    setPracticeSheetListCondition(state, condition: PracticeSheetListCondition){
      state.practiceExamSheetListCondition = condition;
    },
    setPracticeCompareSheetListCondition(state, condition: PracticeCompareSheetListCondition){
      state.practiceCompareSheetListCondition = condition;
    },
    setHomeworkSheetListCondition(state, condition: HomeworkSheetListCondition){
      state.homeworkSheetListCondition = condition;
    },
    setSumupListCondition(state, condition: SumupListCondition){
      state.sumupListCondition = condition;
    },
    setIsShowOverlay(state, isShow: boolean){
      state.isShowOverlay = isShow;
    },
    setOverlayText(state, text: string){
      state.overlayText = text;
    },
    setIsShowProgress(state, isShow: boolean){
      state.isShowProgress = isShow;
    },
    setProgressText(state, text: string){
      state.progressText = text;
    },
    setSheetType(state, sheetType: number){
      state.sheetType = sheetType;
    },
    setIsHeaderDisp(state, isHeaderDisp: boolean){
      state.isHeaderDisp = isHeaderDisp;
    },
    setMainteInfo(state, mainteInfos: any[]){
      state.mainteInfo = new MainteInfo(mainteInfos);
    },
    setDefaultSheetType(state, sheetType: number){
      state.defaultSheetType = sheetType;
    },
    setOtpLoginId(state, otp_login_id: string){
      state.otp_login_id = otp_login_id;
    },
    setSumupResultCurriculumId(state, curriculumId: number){
      state.sumupResultCurriculumId = curriculumId;
    },
    setSumupDetailCurriculumId(state, curriculumId: number){
      state.sumupDetailCurriculumId = curriculumId;
    },
    setGauthCredentials(state, credentials: string){
      state.gauthCredentials = credentials;
    },
    setGauthRedirectPath(state, path: string){
      state.gauthRedirectPath = path;
    },
    setIsDigitalPaper(state, isDigitalPaper: boolean){
      state.isDigitalPaper = isDigitalPaper;
    },
    setDigitalPaperEmail(state, email: string){
      state.digitalPaperEmail = email;
    },
    setIsKaitouViewReloaded(state, value){
      state.isKaitouViewReloaded = value;
    },
    setIsShowingMsgBox(state, isShowingMsgBox: boolean){
      state.isShowingMsgBox = isShowingMsgBox;
    },
    setStudentNoCharacter(state, student_no_character: string){
      state.student_no_character = student_no_character;
    },
    setStudentName(state, student_name: string){
      state.student_name = student_name;
    },
    setSumupUnits(state, sumup_units: any[]){
      state.sumup_units = sumup_units;
    },
    setPracticeCurriculumIds(state, curriculum_ids: any[]){
      state.practiceCurriculumIds = curriculum_ids;
    },
    setNendo(state, nendo: string){
      state.nendo = nendo;
    },
    setExecTimes(state, times: string){
      state.exec_times = times;
    },
    setPracticeExamineeId(state, practice_examinee_id: number){
      state.practice_examinee_id = practice_examinee_id;
    },
    setBase64SchoolLogo(state, base64_school_logo: string){
      state.base64_school_logo = base64_school_logo;
    },
    setIsRecogPositionEditEnable(state, isRecogPositionEditEnable: boolean){
      state.isRecogPositionEditEnable = isRecogPositionEditEnable;
    },
    setNextFieldType(state, next_field_type: number){
      state.next_field_type = next_field_type;
    },
    setStartSheetId(state, sheet_id: number){
      state.start_sheet_id = sheet_id;
    },
    setCompareNo(state, compare_no: number){
      state.compare_no = compare_no;
    },
    setSheetFieldIdx(state, sheet_field_idx: number){
      state.sheet_field_idx = sheet_field_idx;
    },
    setSaitenListDisplayLeft(state, displayLeft: number){
      state.saitenListDisplayLeft = displayLeft;
    },
    setIsFilterMisaiten(state, isFilterMisaiten: boolean){
      state.isFilterMisaiten = isFilterMisaiten;
    },
    setSchoolSubjects(state, schoolSubjects){
      state.schoolSubjects = schoolSubjects;
    },
    setMarkRecogResultColCount(state, rowCount: number){
      state.markRecogResultColCount = rowCount;
    },
    setWebupListCondition(state, condition: WebupListCondition){
      state.webupListCondition = condition;
    },
    setTextDirection(state, direction){
      state.textDirection = direction;
    },
    setFontSize(state, fontSize){
      state.fontSize = fontSize;
    },
    setLineHeight(state, lineHeight){
      state.lineHeight = lineHeight;
    },
  },
  getters: {
    // 教科プルダウン
    getComboboxCurriculums: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const curriculum of state.curriculums){
        rtn.push({value: curriculum.id, text: curriculum.name});
      }
      return rtn;
    },
    // 自分の担当教科プルダウン
    getComboboxMyCurriculums: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(state.currentUser.role == Common.RoleEnum.Teacher2 || state.currentUser.role == Common.RoleEnum.EntranceTeacher2){
        const curriculum_ids = state.currentUser.curriculum_id ? state.currentUser.curriculum_id.split(",") : [];
        if(allowEmpty){
          rtn.push({value: "", text: "-"});
        }
        for(const curriculum of state.curriculums){
          if(curriculum_ids.includes(`${curriculum.id}`)){
            rtn.push({value: curriculum.id, text: curriculum.name});
          }
        }
      }else{
        if(allowEmpty){
          rtn.push({value: "", text: "-"});
        }
        for(const curriculum of state.curriculums){
          rtn.push({value: curriculum.id, text: curriculum.name});
        }
      }
      return rtn;
    },
    // 自分の担当教科プルダウン
    getComboboxMySchoolSubjects: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(state.currentUser.role == Common.RoleEnum.Teacher2){
        if(allowEmpty){
          rtn.push({value: "", text: "-"});
        }
        for(const schoolSubject of state.schoolSubjects){
          if(state.currentUser.subject_codes.includes(`${schoolSubject.subject_code}`)){
            rtn.push({value: schoolSubject.subject_code, text: schoolSubject.name});
          }
        }
      }else{
        if(allowEmpty){
          rtn.push({value: "", text: "-"});
        }
        for(const schoolSubject of state.schoolSubjects){
          rtn.push({value: schoolSubject.subject_code, text: schoolSubject.name});
        }
      }
      return rtn;
    },
    // 観点プルダウン
    getComboboxViewPoints: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      for(const viewPoint of state.viewPoints){
        rtn.push({value: viewPoint.id, text: `${viewPoint.id} : ${viewPoint.name}`});
      }
      return rtn;
    },
    // 実施月プルダウン
    getComboboxMonths: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.months);
    },
    // 学年プルダウン
    getComboboxGrades: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.grades);
    },
    // 試験一覧の学校プルダウン
    getComboboxSchools: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const school of state.schools){
        rtn.push({value: school.id, text: `${school.id} : ${school.name}`});
      }
      return rtn;
    },
    // 正答プルダウン
    getComboboxCorrectTexts: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.correct_texts);
    },
    // 採点方法プルダウン
    getComboboxScoringTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.scoring_types);
    },
    // 解答方法プルダウン
    getComboboxDigitalAnswerTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.digital_answer_types);
    },
    getCurriculumNameById: (state) => (id: number) => {
      const curriculum = state.curriculums.filter(x => x.id == id);
      return curriculum.length > 0 ? curriculum[0].name : "";
    },
    getSubjectNameBySheet: (state, getters) => (sheet: any) => {
      let rtn = "";
      
      if(sheet.sheet_type != Common.SheetTypeEnum.Normal){
        rtn = sheet.subject_name;
      }else if(sheet.subject_name && sheet.subject_code != null){
        rtn = getters.isOptionSchoolSubjectActive ? getters.getSchoolSubjectNameByValue(sheet.subject_code) : sheet.subject_name;
      }else if(sheet.subject_name){
        rtn = sheet.subject_name;
      }else if(sheet.subject_code != null){
        rtn = getters.getSchoolSubjectNameByValue(sheet.subject_code);
      }
      
      return rtn;
    },
    getViewPointNameById: (state) => (id: number) => {
      const viewPoint = state.viewPoints.filter(x => x.id == id);
      return viewPoint.length > 0 ? viewPoint[0].name : "-";
    },
    getGradeNameByValue: (state, getters) => (value: number) => {
      if(getters.isEntranceOrPractice){
        return null;
      }else{
        const grade = state.grades.filter(x => x.value == value);
        return grade.length > 0 ? grade[0].text : "-";
      }
    },
    getComboboxRoles: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.roles);
    },
    getComboboxTeacherRoles: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.teacherRoles);
    },
    getComboboxEntranceTeacherRoles: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.entranceTeacherRoles);
    },
    getComboboxGenders: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.genders);
    },
    getComboboxAssessmentScoreTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.assessment_score_types);
    },
    getComboboxSchoolSubjects: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const schoolSubject of state.schoolSubjects){
        rtn.push({value: schoolSubject.subject_code, text: `${schoolSubject.subject_code} : ${schoolSubject.name}`});
      }
      return rtn;
    },
    getRoleNameByValue: (state) => (value: string) => {
      const role = state.roles.filter(x => x.value == value);
      return role.length > 0 ? role[0].text : "-";
    },
    getGenderNameByCode: (state) => (value: string) => {
      const gender = state.genders.filter(x => x.value == value);
      return gender.length > 0 ? gender[0].text : "-";
    },
    getSchoolSubjectNameByValue: (state, getters) => (code: string) => {
      if(!code){
        return "";
      }
      const schoolSubject = state.schoolSubjects.filter(x => x.subject_code == code);
      return schoolSubject.length > 0 ? schoolSubject[0].name : `${code}(削除)`;
    },
    // 生徒管理オプション有無
    isOptionStudentManageActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.StudentManage && x.active_flg).length > 0;
    },
    // CBT試験オプション有無
    isOptionCbtActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Cbt && x.active_flg).length > 0;
    },
    // 入試オプション有無
    isOptionEntranceActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Entrance && x.active_flg).length > 0;
    },
    // Classroomオプション有無
    isOptionClassroomActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Classroom && x.active_flg).length > 0;
    },
    // Teams試験オプション有無
    isOptionTeamsActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Teams && x.active_flg).length > 0;
    },
    // デジタルペーパーオプション有無
    isOptionDigitalPaperActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.DigitalPaper && x.active_flg).length > 0;
    },
    // メール返却オプション有無
    isOptionMailReturnActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.MailReturn && x.active_flg).length > 0;
    },
    // 模試オプション有無
    isOptionPracticeActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Practice && x.active_flg).length > 0;
    },
    // 課題管理オプション有無
    isOptionHomeworkActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Homework && x.active_flg).length > 0;
    },
    // 試験表示ユーザ自分のみオプション有無
    isOptionSheetViewCreateUserOnlyActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.SheetViewCreateUserOnlyActive && x.active_flg).length > 0;
    },
    // 答案並び順チェック必須オプション有無
    isOptionSortAnswerImageRequiredActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.SortAnswerImageRequired && x.active_flg).length > 0;
    },
    // 学校別教科・科目オプション有無
    isOptionSchoolSubjectActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.SchoolSubject && x.active_flg).length > 0;
    },
    // ヘッダメニュー 権限・オプションにより制御
    headerMenus: (state, getters) => {
      
      const menus: Menu[] = new Array<Menu>();
      
      if(state.currentUser == null){
        return menus;
      }

      if(state.currentUser.role == Common.RoleEnum.Student){
        // 生徒系のメニュー
        menus.push(new Menu("パスワード変更", "address-card", `/${state.currentUser.school_id}/student_site/password_edit`));
        // menus.push(new Menu("メールアドレス変更", "address-card", `/${state.currentUser.school_id}/student_site/mail_edit`));
      }else{
        // 教師系のメニュー
        menus.push(new Menu("ユーザー管理", "address-card", "/teacher_site/user_edit"));
        
        if(state.currentUser.role == Common.RoleEnum.Admin){
          // admin権限
          menus.push(new Menu("試験一覧", "file-alt", "/teacher_site/sheet_list"));
          if(getters.isOptionCbtActive){
            menus.push(new Menu("試験一覧（CBT）", "file-alt", "/teacher_site/cbt_sheet_list"));
          }
          if(getters.isOptionEntranceActive){
            menus.push(new Menu("試験一覧（入試ベリファイ）", "file-alt", "/teacher_site/entrance_sheet_list"));
            menus.push(new Menu("試験一覧（入試コンペア）", "file-alt", "/teacher_site/entrance_compare_sheet_list"));
            menus.push(new Menu("集計（入試）", "file-alt", "/teacher_site/sumup_list"));
          }
          if(getters.isOptionPracticeActive){
            menus.push(new Menu("試験一覧（模試ベリファイ）", "file-alt", "/teacher_site/practice_sheet_list"));
            menus.push(new Menu("試験一覧（模試コンペア）", "file-alt", "/teacher_site/practice_compare_sheet_list"));
            menus.push(new Menu("集計（模試）", "file-alt", "/teacher_site/practice_sumup_list"));
          }

          if(getters.isOptionHomeworkActive){
            menus.push(new Menu("課題一覧", "file-alt", "/teacher_site/homework_sheet_list"));
          }
          menus.push(new Menu("学校一覧", "calendar-alt", "/teacher_site/school_list"));
          
          if(getters.isOptionEntranceActive && getters.isOptionPracticeActive){
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
            menus.push(new Menu("教師一覧(入試・模試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else if(getters.isOptionEntranceActive){
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
            menus.push(new Menu("教師一覧(入試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else if(getters.isOptionPracticeActive){
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
            menus.push(new Menu("教師一覧(模試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else{
            menus.push(new Menu("教師一覧", "graduation-cap", "/teacher_site/teacher_list"));
          }
          
          menus.push(new Menu("生徒一覧", "graduation-cap", "/teacher_site/student_list"));

          if(getters.isOptionSchoolSubjectActive){
            menus.push(new Menu("科目マスタ", "file-alt", "/teacher_site/school_subject_list"));
          }

          if(getters.isOptionStudentManageActive){
            menus.push(new Menu("個別PDF", "upload", "/teacher_site/student_file_upload_list"));
          }
          menus.push(new Menu("試験削除", "envelope", "/teacher_site/sheet_destroy"));

        }else if(state.currentUser.role == Common.RoleEnum.Teacher1){
          // teacher1権限
          menus.push(new Menu("試験一覧", "file-alt", "/teacher_site/sheet_list"));
          if(getters.isOptionCbtActive){
            menus.push(new Menu("試験一覧（CBT）", "file-alt", "/teacher_site/cbt_sheet_list"));
          }
          if(getters.isOptionEntranceActive){
            menus.push(new Menu("試験一覧（入試ベリファイ）", "file-alt", "/teacher_site/entrance_sheet_list"));
            menus.push(new Menu("試験一覧（入試コンペア）", "file-alt", "/teacher_site/entrance_compare_sheet_list"));
            menus.push(new Menu("集計（入試）", "file-alt", "/teacher_site/sumup_list"));
          }
          if(getters.isOptionPracticeActive){
            menus.push(new Menu("試験一覧（模試ベリファイ）", "file-alt", "/teacher_site/practice_sheet_list"));
            menus.push(new Menu("試験一覧（模試コンペア）", "file-alt", "/teacher_site/practice_compare_sheet_list"));
            menus.push(new Menu("集計（模試）", "file-alt", "/teacher_site/practice_sumup_list"));
          }
          if(getters.isOptionHomeworkActive){
            menus.push(new Menu("課題一覧", "file-alt", "/teacher_site/homework_sheet_list"));
          }
          if(getters.isOptionEntranceActive && getters.isOptionPracticeActive){
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
            menus.push(new Menu("教師一覧(入試・模試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else if(getters.isOptionEntranceActive){
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
            menus.push(new Menu("教師一覧(入試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else if(getters.isOptionPracticeActive){
            menus.push(new Menu("教師一覧(通常)", "graduation-cap", "/teacher_site/teacher_list"));
            menus.push(new Menu("教師一覧(模試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else{
            menus.push(new Menu("教師一覧", "graduation-cap", "/teacher_site/teacher_list"));
          }

          menus.push(new Menu("生徒一覧", "graduation-cap", "/teacher_site/student_list"));

          if(getters.isOptionSchoolSubjectActive){
            menus.push(new Menu("科目マスタ", "file-alt", "/teacher_site/school_subject_list"));
          }
          
          if(getters.isOptionStudentManageActive){
            menus.push(new Menu("個別PDF", "upload", "/teacher_site/student_file_upload_list"));
          }
        }else if(state.currentUser.role == Common.RoleEnum.Teacher2){
          // teacher2権限
          menus.push(new Menu("試験一覧", "file-alt", "/teacher_site/sheet_list"));
          if(getters.isOptionCbtActive){
            menus.push(new Menu("試験一覧（CBT）", "file-alt", "/teacher_site/cbt_sheet_list"));
          }
          if(getters.isOptionHomeworkActive){
            menus.push(new Menu("課題一覧", "file-alt", "/teacher_site/homework_sheet_list"));
          }
          menus.push(new Menu("生徒一覧", "graduation-cap", "/teacher_site/student_list"));
          // if(getters.isOptionSchoolSubjectActive){
          //   menus.push(new Menu("科目マスタ", "file-alt", "/teacher_site/school_subject_list"));
          // }
          if(getters.isOptionStudentManageActive){
            menus.push(new Menu("個別PDF", "upload", "/teacher_site/student_file_upload_list"));
          }
        }else if(state.currentUser.role == Common.RoleEnum.EntranceTeacher1){
          // entrance_teacher1権限
          if(getters.isOptionEntranceActive){
            menus.push(new Menu("試験一覧（入試ベリファイ）", "file-alt", "/teacher_site/entrance_sheet_list"));
            menus.push(new Menu("試験一覧（入試コンペア）", "file-alt", "/teacher_site/entrance_compare_sheet_list"));
            menus.push(new Menu("集計（入試）", "file-alt", "/teacher_site/sumup_list"));
          }
          if(getters.isOptionPracticeActive){
            menus.push(new Menu("試験一覧（模試ベリファイ）", "file-alt", "/teacher_site/practice_sheet_list"));
            menus.push(new Menu("試験一覧（模試コンペア）", "file-alt", "/teacher_site/practice_compare_sheet_list"));
            menus.push(new Menu("集計（模試）", "file-alt", "/teacher_site/practice_sumup_list"));
          }
          
          if(getters.isOptionEntranceActive && getters.isOptionPracticeActive){
            menus.push(new Menu("教師一覧(入試・模試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else if(getters.isOptionEntranceActive){
            menus.push(new Menu("教師一覧(入試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }else if(getters.isOptionPracticeActive){
            menus.push(new Menu("教師一覧(模試)", "graduation-cap", "/teacher_site/entrance_teacher_list"));
          }
        }else if(state.currentUser.role == Common.RoleEnum.EntranceTeacher2){
          // entrance_teacher2権限
          if(getters.isOptionEntranceActive){
            menus.push(new Menu("試験一覧（入試ベリファイ）", "file-alt", "/teacher_site/entrance_sheet_list"));
            menus.push(new Menu("試験一覧（入試コンペア）", "file-alt", "/teacher_site/entrance_compare_sheet_list"));
          }
          if(getters.isOptionPracticeActive){
            menus.push(new Menu("試験一覧（模試ベリファイ）", "file-alt", "/teacher_site/practice_sheet_list"));
            menus.push(new Menu("試験一覧（模試コンペア）", "file-alt", "/teacher_site/practice_compare_sheet_list"));
          }
        }

        // menus.push(new Menu("操作マニュアル", "video", "https://smarky.jp/manual/"));
      }
      return menus;
    },
    // システム管理者か判定
    isAdmin: state => {
      return state.currentUser.role == Common.RoleEnum.Admin;
    },
    isTeacher1: state => {
      return state.currentUser.role == Common.RoleEnum.Teacher1 || state.currentUser.role == Common.RoleEnum.EntranceTeacher1;
    },
    isAdminOrTeacher1: state => {
      return state.currentUser.role == Common.RoleEnum.Admin || state.currentUser.role == Common.RoleEnum.Teacher1 || state.currentUser.role == Common.RoleEnum.EntranceTeacher1;
    },
    isNormalSheet: state => {
      return state.sheetType == Common.SheetTypeEnum.Normal;
    },
    isEntranceOrPractice: state => {
      return [Common.SheetTypeEnum.Entrance, Common.SheetTypeEnum.Practice, Common.SheetTypeEnum.EntranceCompare, Common.SheetTypeEnum.PracticeCompare].includes(state.sheetType);
    },
    isHomework: state => {
      return state.sheetType == Common.SheetTypeEnum.Homework;
    },
    isCompare: state => {
      return [Common.SheetTypeEnum.EntranceCompare, Common.SheetTypeEnum.PracticeCompare].includes(state.sheetType);
    },
    isCompareFirstOrSecond: state => {
      return [Common.SheetTypeEnum.EntranceCompare, Common.SheetTypeEnum.PracticeCompare].includes(state.sheetType) && [Common.CompareNoEnum.CompareFirst, Common.CompareNoEnum.CompareSecond].includes(state.compare_no);
    },
    isCompareFinal: state => {
      return [Common.SheetTypeEnum.EntranceCompare, Common.SheetTypeEnum.PracticeCompare].includes(state.sheetType) && ![Common.CompareNoEnum.CompareFirst, Common.CompareNoEnum.CompareSecond].includes(state.compare_no);
    },
  },
  actions: {
    showOverlay(context, payload) {
      let overlayText = "処理実行中... しばらくお待ちください。";
      let isShowProgress = false;
    
      // payloadが文字列なら従来の引数とみなす
      if (typeof payload === "string" || payload == null) {
        overlayText = payload || overlayText;
      }
      // payloadがオブジェクトなら、新形式とみなす
      else if (typeof payload === "object") {
        overlayText = payload.overlayText || overlayText;
        isShowProgress = payload.isShowProgress || false;
      }
    
      context.commit("setIsShowOverlay", true);
      context.commit("setIsShowProgress", isShowProgress);
      context.commit("setProgressText", "0.0");
      context.commit("setOverlayText", overlayText);
    },
    hideOverlay(context){
      context.commit("setIsShowOverlay", false);
      context.commit("setIsShowProgress", false);
    },
    goSheetList(context){
      context.commit("setIsHeaderDisp", true);
      if(context.state.currentUser.role == Common.RoleEnum.Student){
        router.push(`/${context.state.currentUser.school_id}/student_site/sheet_list`);
      }else{
        if(context.state.sheetType == Common.SheetTypeEnum.Entrance){
          router.push('/teacher_site/entrance_sheet_list');
        }else if(context.state.sheetType == Common.SheetTypeEnum.Cbt){
          router.push('/teacher_site/cbt_sheet_list');
        }else if(context.state.sheetType == Common.SheetTypeEnum.Practice){
          router.push('/teacher_site/practice_sheet_list');
        }else if(context.state.sheetType == Common.SheetTypeEnum.Homework){
          router.push('/teacher_site/homework_sheet_list');
        }else if(context.state.sheetType == Common.SheetTypeEnum.EntranceCompare){
          router.push('/teacher_site/entrance_compare_sheet_list');
        }else if(context.state.sheetType == Common.SheetTypeEnum.PracticeCompare){
          router.push('/teacher_site/practice_compare_sheet_list');
        }else{
          router.push('/teacher_site/sheet_list');
        }
      }
    },
    goSumupList(context){
      if(context.state.sheetType == Common.SheetTypeEnum.Entrance || context.state.sheetType == Common.SheetTypeEnum.EntranceCompare){
        router.push("/teacher_site/sumup_list");
      }else if(context.state.sheetType == Common.SheetTypeEnum.Practice || context.state.sheetType == Common.SheetTypeEnum.PracticeCompare){
        router.push("/teacher_site/practice_sumup_list");
      }
    }
  },
  modules: {
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
})
